import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import axiosInstance from "../../utils/axiosInstance";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { fetchAcceptedPendingAppointmentsOfDoctorByDate, fetchAppointmentDetails, fetchDoctorProfile, fetchPatients, imageBaseUrl, rescheduleAppointment } from "../../constants/ApiConstants";
import AppointmentWithContactInfoSection from "../../components/Section/AppointmentWithContactInfoSection";
import BookingDateSelector from "./comps/BookingDateSelector";
import { useSelector } from "react-redux";
import AvailableSlots from "./comps/AvailableSlots";
import Spinner from "../../components/Spinner";
import AppointmentTypeSelector from "./comps/AppointmentTypeSelector";
import PatientSelector from "./comps/PatientSelector";
import DescribeProblem from "./comps/DescribeProblem";
import ImageSelector from "../../components/ImageSelector";
import styled from "styled-components";
import { linearTopGradient } from "../../constants/colors";
import toast from "react-hot-toast";
import FullPageLoader from "../../components/FullPageLoader";
import { parseISO } from "date-fns";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";

export default function AppointmentDateSelectPage() {
  pageTitle("Take Appointments");

  const id = useParams().doctorId;
  const [searchParams, setSearchParams] = useSearchParams();
  const [doctorDetail, setDoctorDetail] = useState("");
  const [userDetail, setUserDetail] = useState(null);
  const [doctorId, setDoctorId] = useState(id);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const userId = useSelector((state) => state.appSlice.userData?.id);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState();
  const [appointmentsByDateFetching, setAppointmentByDateFetching] = useState(false);
  const [bookedAppointments, setBookedAppointments] = useState();
  const [appointmentType, setAppointmentType] = useState();
  const [patient, setPatient] = useState(0);
  const [patientList, setPatientList] = useState([]);
  const [images, setImages] = useState();
  const [appointmentTypes, setAppointmentTypes] = useState(["Online", "Clinic"]);
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // reschedule stuffs
  const [appointmentData, setAppointmentData] = useState(null);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);

  const appTaxes = useSelector((state) => state.appSlice.settings.taxes);
  const dateLimit = 90;
  const navigate = useNavigate();
  const fetchDoctorDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorProfile, {
        doctor_id: doctorId,
      })
      .then((res) => {
        setDoctorDetail(res.data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchAppointmentIfRescheduling = () => {
    if (searchParams.get("appointmentId")) {
      axiosInstance
        .post(fetchAppointmentDetails, {
          user_id: userId,
          appointment_id: searchParams.get("appointmentId"),
        })
        .then((res) => {
          if (res.data?.status) {
            setAppointmentData(res.data?.data);
            setAppointmentType(res?.data?.data?.type === 0 ? "Online" : "Clinic");
            setPatient(res?.data?.data?.patient_id || res?.data?.data?.user.id);
            setReason(res?.data?.data?.problem);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  function fetchPatientList() {
    axiosInstance
      .post(fetchPatients, {
        user_id: userId,
      })
      .then((res) => {
        setPatientList(res.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const getBookingDates = () =>
    Array.from({ length: dateLimit }, (_, i) => {
      const now = new Date();
      const nextDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
      return nextDay;
    });
  const [bookingDates, setBookingDates] = useState(getBookingDates());
  const isFromReschedule = searchParams.get("appointmentId") && appointmentData;

  useEffect(() => {
    fetchDoctorDetail();
    fetchAppointmentIfRescheduling();
    fetchPatientList();
    setSelectedDate(bookingDates[0]);
    setInitialAppointmentType();
  }, []);

  useEffect(() => {
    if (doctorDetail && selectedDate) {
      fetchAcceptedPendingAppointmentsOfDoctor();
      filterSlotsByDateAndFormat();
      // fetchAcceptedPendingAppointmentsOfDoctor();
    }
  }, [doctorDetail, selectedDate]);

  const setInitialAppointmentType = () => {
    if (doctorDetail) {
      const online = doctorDetail?.online_consultation == 1;
      const clinic = doctorDetail?.clinic_consultation == 1;
      const types = [];
      if (online) types.push("Online");
      if (clinic) types.push("Clinic");

      if (types.length > 0) {
        console.log(types);
        setAppointmentType(types[0]);
      }
    }
  };

  function formatTime(slotTime) {
    const hours = slotTime.slice(0, 2);
    const minutes = slotTime.slice(2, 4);
    return `${hours}:${minutes}`;
  }

  function getCurrentTime() {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${hours}${minutes}`;
  }

  function filterSlotsByDateAndFormat() {
    const weekday = selectedDate.getDay() === 0 ? 7 : selectedDate.getDay();
    const currentDay = new Date();
    const currentTime = getCurrentTime();
    let filteredSlots = doctorDetail?.slots
      .sort((a, b) => parseInt(a.time) - parseInt(b.time))
      .filter((slot) => {
        if (slot.weekday === weekday) {
          if (`${selectedDate.getFullYear()}-${selectedDate.getMonth() + 1}-${selectedDate.getDate()}` === `${currentDay.getFullYear()}-${currentDay.getMonth() + 1}-${currentDay.getDate()}` && currentTime > slot.time) {
            return false;
          }
          return true;
        }
        return false;
      });
    const newFilteredSlots = filteredSlots.map((slot) => ({
      ...slot,
      formattedTime: formatTime(slot.time),
    }));
    setAvailableSlots(newFilteredSlots);
  }

  const fetchAcceptedPendingAppointmentsOfDoctor = () => {
    setAppointmentByDateFetching(true);
    axiosInstance
      .post(fetchAcceptedPendingAppointmentsOfDoctorByDate, {
        doctor_id: id,
        date: `${selectedDate.getFullYear()}-${selectedDate.getMonth() + 1}-${selectedDate.getDate()}`,
      })
      .then((res) => {
        setBookedAppointments(res.data.data);
        setSelectedSlot();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setAppointmentByDateFetching(false);
      });
  };

  const validateAndSubmit = () => {
    console.log({
      selectedDate,
      selectedSlot,
      appointmentType,
      reason,
      patient,
    });
    if (!selectedDate) {
      toast.error("Appointment date is required.");
      return;
    }
    if (!selectedSlot) {
      toast.error("Please select a slot");
      return;
    }
    if (!appointmentType) {
      toast.error("Please choose a type of appointment");
      return;
    }

    if (!reason) {
      toast.error("Please explain your problem");
      return;
    }
    const subtotal = parseFloat(doctorDetail.consultation_fee);
    let payable_amount = parseFloat(doctorDetail.consultation_fee);
    let total_tax_amount = 0;
    const taxes = [];
    for (const taxItem of appTaxes) {
      let taxAmount;
      if (taxItem.type == 0) {
        // percent
        taxAmount = (subtotal * parseFloat(taxItem.value)) / 100;
      } else if (taxItem.type == 1) {
        taxAmount = parseFloat(taxItem.value);
      }
      total_tax_amount += taxAmount;
      payable_amount += taxAmount;
      taxes.push({ ...taxItem, tax_amount: taxAmount });
    }

    const appointmentData = {
      user_id: userId,
      doctor_id: id,
      problem: reason,
      date: `${selectedDate.getFullYear()}-${selectedDate.getMonth() + 1}-${selectedDate.getDate()}`,
      type: appointmentType === "Online" ? 0 : 1,
      time: selectedSlot.time,
      order_summary: {
        service_amount: parseInt(doctorDetail?.consultation_fee),
        discount_amount: 0,
        subtotal: parseInt(subtotal),
        payable_amount: parseInt(payable_amount),
        coupon_apply: 0,
        taxes,
      },
      is_coupon_applied: 0,
      service_amount: parseFloat(doctorDetail?.consultation_fee),
      discount_amount: 0,
      subtotal,
      total_tax_amount,
      payable_amount,
      documents: images.map((img) => img.file),
    };

    console.log(images);
    if (patient != 0) {
      appointmentData["patient_id"] = patient;
    }

    navigate("/appointment-summary", {
      state: {
        doctorData: doctorDetail,
        appointmentData,
      },
    });
  };

  const handleRescheduleClick = () => {
    if (!selectedDate) {
      toast.error("Appointment date is required.");
      return;
    }
    if (!selectedSlot) {
      toast.error("Please select a slot");
      return;
    }
    axiosInstance
      .post(rescheduleAppointment, {
        doctor_id: doctorId,
        user_id: userId,
        appointment_id: appointmentData?.id,
        date: `${selectedDate.getFullYear()}-${selectedDate.getMonth() + 1}-${selectedDate.getDate()}`,
        time: selectedSlot.time,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Appointment rescheduled successfully.");
          navigate(-1);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(true);
      });
  };

  return (
    <>
      {/* <BannerSectionStyle3 bgUrl="/images/appointments/banner_bg.svg" imgUrl="/images/appointments/banner_img.png" title="Don’t Let Your Health Take a Backseat!" subTitle="Fill out the appointment form below to schedule a consultation with one of our healthcare professionals." /> */}
      <Section topMd={60} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        {loading ? (
          <FullPageLoader />
        ) : (
          <div className="content-wrapper">
            <CommonMobileHeader canBack title="Select Date & Time" />
            <div className="row">
              <div className="col-md-6">
                <DoctorContainer className="px-2">
                  <div className="doctor__image w-full rounded">
                    <img className="" src={`${imageBaseUrl}${doctorDetail.image}`} />
                  </div>
                  <div className="doctor__info m-3">
                    <strong className="doctor__name text-black">{doctorDetail.name}</strong>
                    <div className="doctor__designation d-flex align-items-center gap-1 fs-md">
                      <img src={"/images/stethoscope.png"} />
                      {doctorDetail.designation}
                    </div>
                    <span className="doctor__degrees text-grey2 fs-md">{doctorDetail.degrees}</span>
                  </div>
                </DoctorContainer>
              </div>
              <div className="col-md-6">
                <BookingDateSelector dates={bookingDates} selectedDate={selectedDate} onDateClick={setSelectedDate} />
                <AvailableSlots bookedAppoinments={bookedAppointments} fetching={appointmentsByDateFetching} slots={availableSlots} selectedSlot={selectedSlot} onSlotSelect={setSelectedSlot} />
                <AppointmentTypeSelector type={appointmentType} isClinicVisible={doctorDetail?.clinic_consultation == 1} isOnlineVisible={doctorDetail?.online_consultation == 1} onSelect={setAppointmentType} />
                <PatientSelector readOnly={isFromReschedule} defaultValue={patient} patients={patientList} onChange={setPatient} />
                <DescribeProblem readOnly={isFromReschedule} value={reason} onChange={(e) => setReason(e.target.value)} />
                {isFromReschedule ? <></> : <ImageSelector onImagesChange={setImages} />}
                {isFromReschedule ? (
                  <GradientButton type="button" className="btn-gradient cs_shadow_1" onClick={handleRescheduleClick}>
                    Reschedule
                  </GradientButton>
                ) : (
                  <GradientButton type="button" className="btn-gradient cs_shadow_1" onClick={validateAndSubmit}>
                    Make Payment
                  </GradientButton>
                )}
              </div>
            </div>
          </div>
        )}
      </Section>
    </>
  );
}

const DoctorContainer = styled.div`
  display: flex;
  padding-bottom: 0.75rem;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  margin-bottom: 1rem;

  b span {
    color: gray;
    font-size: 0.9rem;
  }
  .doctor__designation img {
    height: 12px;
  }

  .doctor__image img {
    height: 100px;
    width: 100px;
    object-fit: contain;
    border-radius: 16px;
  }

  .doctor__image {
    width: max-content;
  }

  @media screen and (min-width: 768px) {
    flex-direction: column;
    .doctor__designation {
      display: block !important;
    }
    .doctor__name {
      font-size: 3rem;
      margin-top: 2rem;
      text-align: center;
    }
    .doctor__image img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
    .doctor__image {
      height: 450px;
    }
    .doctor__info {
      margin: 0 auto;
      width: 100%;
      text-align: center;
      margin-top: 2rem;
    }
  }
`;
const GradientButton = styled.button`
  position: static;
  margin-top: 1rem;
  left: 0;
  right: 0;
  padding: 14px 16px 16px 14px;
  bottom: 0;
  color: #fff;
  outline: none;
  border: none;
  background: ${linearTopGradient};
  z-index: 5;
  border-radius: 8px;
  width: 100%;
  margin-left: 12px;
  margin-right: 12px;

  @media screen and (max-width: 768px) {
    position: fixed;
    margin: 0;
    border-radius: 0;
    bottom: 0;
  }
`;
